import { useCallback, useState } from "react";
import { AnimatePresence } from "motion/react";
import { Link } from "react-router-dom";
import {
  faqUrl,
  getFaqCategoriesForArticle,
  useFaqData
} from "../../hooks/FaqHooks";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import SimpleOverlay from "../modal/SimpleOverlay";
import FaqItem from "./FaqItem";
import { useLang } from "../../hooks/LangHooks";
import find from "lodash/find";
import { stripHtml } from "string-strip-html";
import { Product } from "../../types/Product";
import { useHistory } from "react-router";
import "./style.scss";

const ProductFaq = ({ product }: { product: Product }) => {
  const t = useBjelinTranslations();
  const history = useHistory();
  const lang = useLang();
  const faqData = useFaqData(lang);
  const [selectedQuestionId, setSelectedQuestionId] = useState<string>();

  const resetSelectedQuestion = useCallback(() => {
    setSelectedQuestionId(undefined);
  }, []);

  const filteredQuestions = faqData.articles.filter(
    article =>
      (product.productType &&
        article.product_types.indexOf(product.productType) >= 0) ||
      article.products.indexOf(product._id) >= 0
  );
  const selectedItem = find(faqData.articles, { _id: selectedQuestionId });
  const selectedCategory = selectedItem
    ? getFaqCategoriesForArticle(faqData, selectedItem)[0]
    : undefined;

  return filteredQuestions.length > 0 ? (
    <div className="product-faq" style={{ marginTop: "2em" }}>
      <h2>{t("faq.title")}</h2>

      <ul className="faq-items" style={{ margin: 0 }}>
        {filteredQuestions.map(article => {
          const category = getFaqCategoriesForArticle(faqData, article)[0];
          return (
            <li className="faq-item-thumb" key={article.id}>
              <Link to={faqUrl({ category, article })}>
                <div className="text-container">
                  <h3>{article.title}</h3>
                  <p>
                    {stripHtml(article.description).result.substring(0, 125)}...
                    ({t("read.more")})
                  </p>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
      <AnimatePresence>
        {selectedItem && selectedCategory && (
          <SimpleOverlay
            close={() => {
              resetSelectedQuestion();
              history.replace(
                faqUrl({ category: selectedCategory, article: selectedItem })
              );
            }}
          >
            <FaqItem
              article={selectedItem}
              category={selectedCategory}
              onTagClick={resetSelectedQuestion}
              key={selectedItem.id}
            />
          </SimpleOverlay>
        )}
      </AnimatePresence>
      <Link to={faqUrl({})}>{t("faq.more-product-questions")}</Link>
    </div>
  ) : null;
};

export default ProductFaq;
